import React, { useEffect, useMemo, useState } from "react";
import { BeatLoader } from "react-spinners";
import { FaEdit, FaTrash } from "react-icons/fa";
import CommanImagePDf from "./common/CommanImagePDf";
import PhoneInput from "react-country-phone-input";
import Swal from "sweetalert2";
import axiosClient from "../Services/Axios/axios";
import { useLocation, useNavigate } from "react-router-dom";
import countryList from "react-select-country-list";
import Select from "react-select";

const RegisterYourBussiness = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [businessStatus, setBusinessStatus] = useState("none");
  const [editable, setEditable] = useState("edit");
  const [updateAPI, setUpdateAPI] = useState(false);
  const [rejectedReason, setRejectedReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [errors, setErrors] = useState({});
  const [showModifyForm, setShowModifyForm] = useState(false);
  const [phoneCountry, setPhoneCountry] = useState("th");
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [companyRegistration, setCompanyRegistration] = useState({
    companyRegistration: "",
  });
  const [NGOLicense, setNGOLicense] = useState({
    ngo_license: "",
  });
  const [countryData, setCountryData] = useState([]);
  const [errorsValidation, setErrorsValidation] = useState({});
  const [organizationData, setOrganizationData] = useState({
    organization_name: "",
    organization_location: "",
    organization_email: "",
    organization_mobile_no: "",
    organization_mobileCode: "",
    organization_website: "",
    organization_type: "ngo",
    country: "",
    country_id: "",
    about_organization: "",
    organization_banner_image: "",
    company_image: "",
    company_logo: "",
    fullMobile: "",
    organization_documents: [],
    social_media: [{ name: "Facebook", value: "" }],
  });

  const options = useMemo(() => countryList().getData(), []);

  const handleProfile = async () => {
    const response = await axiosClient.get(
      `/users/${process.env.REACT_APP_API_VERSION}/getByID`
    );
    if (!response.data.error) {
      localStorage.setItem("userData", JSON.stringify(response.data.data));
    }
  };
  const handleMobileChange = (value, country) => {
    setOrganizationData({
      ...organizationData,
      fullMobile: value,
      organization_mobile_no: value.slice(country.dialCode.length),
      organization_mobileCode: `+${country.dialCode}`,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let formIsValid = true;
    let errors = {};

    /** ----------------------------
    * Validations
      ---------------------------- */

    if (!organizationData.organization_name) {
      formIsValid = false;
      errors.organization_name = "Organisation name is required";
    }

    if (!organizationData.organization_email) {
      formIsValid = false;
      errors.organization_email = "Organization email is required";
    } else if (!/\S+@\S+\.\S+/.test(organizationData.organization_email)) {
      formIsValid = false;
      errors.organization_email = "Organization email is invalid";
    }

    if (!organizationData.organization_mobile_no) {
      formIsValid = false;
      errors.organization_mobile_no = "Organization mobile number is required";
    }

    if (!organizationData.organization_website) {
      formIsValid = false;
      errors.organization_website = "Website is required";
    }

    if (!organizationData.about_organization) {
      formIsValid = false;
      errors.about_organization = "About organization is required";
    }

    if (!organizationData.organization_location) {
      formIsValid = false;
      errors.organization_location = "Organization location is required";
    }

    if (!organizationData.fullMobile) {
      formIsValid = false;
      errors.fullMobile = "Full mobile number is required";
    }
    if (!organizationData.country_id) {
      formIsValid = false;
      errors.organization_country = "Country is required";
    }
    if (!organizationData.organization_type) {
      formIsValid = false;
      errors.organization_type = "Organization type is required";
    }
    if (uploadedFiles.length === 0) {
      formIsValid = false;
      errors.updatedFiles = "At least one file is required";
    }

    setErrorsValidation(errors);
    if (!formIsValid) return;

    //   /** ----------------------------
    //    * API Call
    //    ---------------------------- */
    try {
      setLoading(true);
      if (businessStatus === "rejected" || updateAPI === true) {
        const response = await axiosClient.post(
          `company/${process.env.REACT_APP_API_VERSION}/update-company-details`,
          {
            id: location.state?.data.id
              ? location.state?.data.id
              : sessionStorage.getItem("company_id"),
            status: 3,
            organization_name: organizationData.organization_name,
            organization_location: organizationData.organization_location,
            organization_email: organizationData.organization_email,
            organization_mobile_no: organizationData.organization_mobile_no,
            organization_mobileCode: organizationData.organization_mobileCode,
            organization_type: organizationData.organization_type,
            country: organizationData.country,
            country_id: organizationData.country_id,
            organization_website: organizationData.organization_website,
            about_organization: organizationData.about_organization,
            company_registration: companyRegistration.companyRegistration,
            ngo_license: NGOLicense.ngo_license,
            social_links: organizationData.social_media.map((item) => ({
              platform: item.name,
              url: item.value,
            })),
            organization_documents: uploadedFiles.map((file) => ({
              document_url: file,
            })),
          }
        );
        if (!response.data.error)
          Swal.fire({
            icon: "success",
            title: response.data.message || "Organization updated successfully",
          });
        setBusinessStatus("pending");
        handleProfile();
        setIsPreview(true);
      } else {
        const response = await axiosClient.post(
          `company/${process.env.REACT_APP_API_VERSION}/create-company-details`,
          {
            organization_name: organizationData.organization_name,
            organization_location: organizationData.organization_location,
            organization_email: organizationData.organization_email,
            organization_mobile_no: organizationData.organization_mobile_no,
            organization_mobileCode: organizationData.organization_mobileCode,
            organization_type: organizationData.organization_type,
            country: organizationData.country,
            country_id: organizationData.country_id,
            organization_website: organizationData.organization_website,
            about_organization: organizationData.about_organization,
            company_registration: companyRegistration.companyRegistration,
            ngo_license: NGOLicense.ngo_license,
            social_links: organizationData.social_media.map((item) => ({
              platform: item.name,
              url: item.value,
            })),
            organization_documents: uploadedFiles.map((file) => ({
              document_url: file,
            })),
          }
        );

        if (!response.data.error) {
          Swal.fire({
            icon: "success",
            title: response.data.message || "Organization created successfully",
          });
          setBusinessStatus("pending");
          sessionStorage.setItem("company_id", response.data.data.id);
          handleProfile();
          setIsPreview(true);
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Failed to update profile",
        text: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };
  const confirmationReject = (type) => {
    if (type === "yes") {
      setEditable("edit");
      Swal.fire({
        icon: "success",
        title: "Modify Application",
        text: "You can only modify and re-apply your application now.",
      });
    }
    if (type === "no") {
      setEditable("disable");
      Swal.fire({
        icon: "warning",
        title: "Modify Application",
        text: "You have chosen not to modify your application. You will not be able to re-apply.",
      });
    }
  };

  // ✅ Handle multiple social links
  const handleSocialMediaChange = (index, field, value) => {
    const updatedSocialMedia = organizationData.social_media.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setOrganizationData((prevState) => ({
      ...prevState,
      social_media: updatedSocialMedia,
    }));
    setErrors((prevState) => {
      const updatedErrors = { ...prevState };
      updatedErrors[`social_media_${index}_${field}`] = "";
      return updatedErrors;
    });
  };

  const addSocialLink = () => {
    setOrganizationData({
      ...organizationData,
      social_media: [
        ...organizationData.social_media,
        { name: "Facebook", value: "" },
      ],
    });
  };
  const removeSocialLink = (index) => {
    const updated = [...organizationData.social_media];
    updated.splice(index, 1);
    setOrganizationData({ ...organizationData, social_media: updated });
  };

  const uploadFile = async (file, onSuccess) => {
    try {
      const maxFileSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxFileSize) {
        Swal.fire({
          icon: "error",
          title: "File size exceeds 5MB",
          text: "Please upload a file smaller than 5MB.",
        });
        return;
      }

      const formData = new FormData();
      formData.append("image", file);

      const response = await axiosClient.post("users/uploadimg", formData);
      if (!response.data.error) {
        onSuccess(response.data.file);
      } else {
        Swal.fire({
          icon: "error",
          title: "Upload failed",
          text: response.data.message || "Something went wrong!",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Upload failed",
        text: error.message || "Something went wrong!",
      });
    }
  };
  // ✅ Handle single file (display/banner)
  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    uploadFile(file, (uploadedFile) => {
      const updatedFiles = [...uploadedFiles];
      updatedFiles[index] = uploadedFile; // ✅ Update exact index

      setUploadedFiles(updatedFiles);
    });
  };
  const addNewFileField = () => {
    setUploadedFiles([...uploadedFiles, ""]);
  };

  const removeFileField = (index) => {
    const updated = [...uploadedFiles];
    updated.splice(index, 1);
    setUploadedFiles(updated);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setIsPreview(false);
    setEditable("edit");
    setUpdateAPI(true);
  };

  const singleOrganizationData = async () => {
    try {
      setLoading(true);
      const response = await axiosClient.get(
        `company/${process.env.REACT_APP_API_VERSION}/organization/${location.state?.data.id}`
      );

      if (!response.data.error) {
        const data = response.data.data;

        setRejectedReason(data.reject_reason || "");
        setUploadedFiles(
          data.organization_documents.map((doc) => doc.document_url)
        );

        // 👉 API se aayi country ka naam nikaal lo
        const apiCountryName =
          typeof data.country === "object" ? data.country.name : data.country;

        // 👉 react-select-country-list se matching country code nikaalo
        const matched = options.find(
          (opt) =>
            opt.label.toLowerCase() === (apiCountryName || "").toLowerCase()
        );

        // 👉 PhoneInput ke liye 2-letter country code (ex: "IN" -> "in")
        const phoneCountryCode = matched ? matched.value.toLowerCase() : "in";

        // ✅ PhoneInput ke liye state set karo
        setPhoneCountry(phoneCountryCode);

        setOrganizationData({
          ...organizationData,
          organization_name: data.organization_name,
          organization_location: data.organization_location,
          organization_email: data.organization_email,
          organization_mobile_no: data.organization_mobile_no,
          organization_mobileCode: data.organization_mobileCode,
          organization_website: data.organization_website,
          fullMobile: `${data.organization_mobileCode}${data.organization_mobile_no}`,
          country: apiCountryName || "",
          country_id: String(data.country_id),
          organization_type: data.organization_type,
          about_organization: data.about_organization,
          organization_banner_image: data.organization_banner_image,
          social_media: data.social_links.map((item) => ({
            name: item.platform,
            value: item.url,
          })),
        });
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getCountryData = async () => {
    try {
      const response = await axiosClient.get(`/country/get-selected-country`);

      if (!response.data.error) {
        setCountryData(response.data.data); // ✅ THIS IS CORRECT
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getCountryData();
    if (location.state?.data) {
      singleOrganizationData();
      setBusinessStatus(
        location?.state?.data.status === 2 ? "rejected" : "none"
      );
      setEditable(location?.state?.data.status === 2 ? "disable" : "edit");
    }
  }, [location]);
  if (loading)
    return (
      <div className="loader">
        <BeatLoader color="#097C81" />
      </div>
    );
  return (
    <>
      <section>
        <img
          src="/images/register-bussiness.jpg"
          className="company-registration-bgImg"
          alt=""
        />
        <div className="overlayy"></div>
        <div className="register-bussiness-text">
          <h1>Apply as Company / NGO</h1>
          <p>
            Lorem ipsum dolor sit amet, Sed consequatur necessitatibus aut natus
            minima eum obcaecati voluptas et aliquam soluta. Aut quia minus.
          </p>
        </div>
      </section>

      <section className="ser_v_araeea" id="careers_pgs">
        <div className="form-container">
          <form className="register-form" onSubmit={handleSubmit}>
            {/* ✅ Application Rejected Section */}
            {businessStatus === "rejected" && !showModifyForm && (
              <div className="rejected-container">
                <p className="rejected-title">
                  *Your Application for Company / NGO has been Rejected
                </p>
                {rejectedReason !== "" && (
                  <>
                    {" "}
                    <div className="section-header">Reason</div>
                    <p>{rejectedReason}</p>
                  </>
                )}

                <hr className="divider" />

                <div className="modify-section">
                  <h3>Do You Want To Modify And Re-Apply</h3>
                  <div className="button-group">
                    <button
                      type="button"
                      className="btn-no"
                      onClick={() => confirmationReject("no")}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn-yes"
                      onClick={() => confirmationReject("yes")}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Organisation Details */}
            <div className="section-header">
              Organisation Details
              {isPreview && (
                <button className="edit-icon" onClick={handleEdit}>
                  Edit
                </button>
              )}
            </div>

            {isPreview ? (
              <div className="preview-grid">
                <p>
                  <strong>Organisation Name</strong>
                  <span>{organizationData.organization_name}</span>
                </p>
                <p>
                  <strong>Email Address</strong>
                  <span>{organizationData.organization_email}</span>
                </p>
                <p>
                  <strong>Location</strong>
                  <span>{organizationData.organization_location}</span>
                </p>
                <p>
                  <strong>Mobile No.</strong>
                  <span>
                    {organizationData?.organization_mobileCode}{" "}
                    {organizationData?.organization_mobile_no}
                  </span>
                </p>
                <p>
                  <strong>Country</strong>
                  <span>{organizationData.country}</span>
                </p>
                <p>
                  <strong>Organisation Type</strong>
                  <span>{organizationData.organization_type}</span>
                </p>
                <p>
                  <strong>Website</strong>
                  <span>{organizationData?.organization_website}</span>
                </p>
              </div>
            ) : (
              <div className="form-grid">
                <div>
                  <label>Organisation Name</label>
                  <input
                    maxLength={50}
                    name="organization_name"
                    className={`form-control ${
                      errorsValidation.organization_name ? "input-error" : ""
                    }`}
                    placeholder="Organisation Name"
                    value={organizationData.organization_name}
                    onChange={(e) => {
                      setErrorsValidation({
                        ...errorsValidation,
                        organization_name: "",
                      });
                      setOrganizationData({
                        ...organizationData,
                        organization_name: e.target.value,
                      });
                    }}
                    disabled={editable === "disable"}
                  />
                  {errors.organization_name && (
                    <span className="error">{errors.organization_name}</span>
                  )}
                </div>
                <div>
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    className={`form-control ${
                      errorsValidation.organization_email ? "input-error" : ""
                    }`}
                    placeholder="Email Address"
                    value={organizationData.organization_email}
                    onChange={(e) => {
                      setErrorsValidation({
                        ...errorsValidation,
                        organization_email: "",
                      });
                      setOrganizationData({
                        ...organizationData,
                        organization_email: e.target.value,
                      });
                    }}
                    disabled={editable === "disable"}
                  />
                  {errorsValidation.organization_email && (
                    <span className="error">
                      {errorsValidation.organization_email}
                    </span>
                  )}
                </div>
                <div>
                  <label>Location</label>
                  <input
                    name="location"
                    className={`form-control ${
                      errorsValidation.organization_location
                        ? "input-error"
                        : ""
                    }`}
                    placeholder="Location"
                    value={organizationData.organization_location}
                    onChange={(e) => {
                      setErrorsValidation({
                        ...errorsValidation,
                        organization_location: "",
                      });
                      setOrganizationData({
                        ...organizationData,
                        organization_location: e.target.value,
                      });
                    }}
                    disabled={editable === "disable"}
                  />
                  {errorsValidation.organization_location && (
                    <span className="error">
                      {errorsValidation.organization_location}
                    </span>
                  )}
                </div>
                <div>
                  <label>Country</label>
                  <select
                    name="country"
                    value={organizationData.country_id}
                    onChange={(e) => {
                      setErrorsValidation({
                        ...errorsValidation,
                        organization_country: "",
                      });

                      const selectedName =
                        e.target.options[e.target.selectedIndex].text;

                      // PhoneInput country set karo
                      const matched = options.find(
                        (opt) =>
                          opt.label.toLowerCase() ===
                          (selectedName || "").toLowerCase()
                      );
                      setPhoneCountry(
                        matched ? matched.value.toLowerCase() : "th"
                      );

                      setOrganizationData({
                        ...organizationData,
                        country_id: e.target.value,
                        country: selectedName,
                      });
                    }}
                    disabled={editable === "disable"}
                  >
                    <option value="">Select a country</option>

                    {countryData.map((res, i) => (
                      <option key={i} value={res.id}>
                        {res.name}
                      </option>
                    ))}
                  </select>

                  {errorsValidation.country && (
                    <span className="error">{errorsValidation.country}</span>
                  )}
                </div>

                <div>
                  <label>Mobile No.</label>
                  <PhoneInput
                    className={`react-tel-input ${
                      errorsValidation.organization_mobile_no
                        ? "input-error"
                        : ""
                    }`}
                    placeholder="Enter Phone Number"
                    country={phoneCountry} // ✅ yahan se dynamic aa raha hai
                    value={organizationData.fullMobile || "+66"}
                    onChange={(value, country) => {
                      setErrorsValidation({
                        ...errorsValidation,
                        organization_mobile_no: "",
                      });

                      handleMobileChange(value, country);
                    }}
                    disabled={editable === "disable"}
                  />

                  {errorsValidation.organization_mobile_no && (
                    <span className="error">
                      {errorsValidation.organization_mobile_no}
                    </span>
                  )}
                </div>
                <div className="">
                  <label>Website</label>
                  <input
                    name="organization_website"
                    className={`form-control ${
                      errorsValidation.organization_website ? "input-error" : ""
                    }`}
                    placeholder="Website"
                    value={organizationData.organization_website}
                    onChange={(e) => {
                      setErrorsValidation({
                        ...errorsValidation,
                        organization_website: "",
                      });
                      setOrganizationData({
                        ...organizationData,
                        organization_website: e.target.value,
                      });
                    }}
                    disabled={editable === "disable"}
                  />
                  {errorsValidation.organization_website && (
                    <span className="error">
                      {errorsValidation.organization_website}
                    </span>
                  )}
                </div>
                <div className="">
                  <label>Organisation type</label>
                  <div className="form-group" id="rediiobnt">
                    <div class="rdo_boxx marg_bothss">
                      <p>
                        <input
                          name="role_type"
                          value="ngo"
                          type="radio"
                          id="ngo"
                          checked={organizationData.organization_type === "ngo"}
                          onChange={(e) =>
                            setOrganizationData({
                              ...organizationData,
                              organization_type: e.target.value,
                            })
                          }
                        />
                        <label for="ngo">NGO</label>
                      </p>
                      <p>
                        <input
                          type="radio"
                          id="company"
                          name="role_type"
                          value="company"
                          // value={organizationData.organization_type}
                          checked={
                            organizationData.organization_type === "company"
                          }
                          onChange={(e) =>
                            setOrganizationData({
                              ...organizationData,
                              organization_type: e.target.value,
                            })
                          }
                        />
                        <label for="company">Company</label>
                      </p>
                    </div>
                    {errorsValidation.organization_type && (
                      <span className="error">
                        {errorsValidation.organization_type}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Social Media Links */}
            <div className="sub-header">
              Social Media Links
              {!isPreview && (
                <button
                  type="button"
                  className="add-link-btn"
                  onClick={addSocialLink}
                >
                  Add Link
                </button>
              )}
            </div>
            <hr />
            {isPreview ? (
              <div className="social-preview-list">
                {organizationData.social_media.map((item, i) => (
                  <div key={i} className="social-row">
                    <strong>{item.name}</strong>
                    <span>{item.value}</span>
                  </div>
                ))}
              </div>
            ) : (
              organizationData.social_media.map((item, idx) => (
                <div key={idx} className="social-links">
                  <div className="social-input">
                    <label>Choose Platform</label>
                    <select
                      name="platform"
                      value={item.name || "Facebook"} // Ensure default is an empty string
                      onChange={(e) =>
                        handleSocialMediaChange(idx, "name", e.target.value)
                      }
                      disabled={editable === "disable"}
                    >
                      <option value="">Choose platform</option>
                      <option>Facebook</option>
                      <option>Instagram</option>
                      <option>LinkedIn</option>
                      <option>Twitter</option>
                    </select>
                  </div>

                  <div className="social-input">
                    <label>Enter Link</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter URL"
                      value={item.value || ""} // Ensure no undefined value
                      onChange={(e) =>
                        handleSocialMediaChange(idx, "value", e.target.value)
                      }
                      disabled={editable === "disable"}
                    />
                    {errors[`social_media_${idx}_value`] && (
                      <small className="text-danger">
                        {errors[`social_media_${idx}_value`]}
                      </small>
                    )}
                  </div>

                  {idx > 0 && (
                    <button
                      type="button"
                      className="social-delete-btn"
                      onClick={() => removeSocialLink(idx)}
                    >
                      <FaTrash size={18} />
                    </button>
                  )}
                </div>
              ))
            )}

            {/* Description */}
            <div className="sub-header">Description</div>
            <hr />
            {isPreview ? (
              <div className="about-preview">
                <div className="about-row">
                  <strong>About Organisation</strong>
                  <span>{organizationData.about_organization}</span>
                </div>
              </div>
            ) : (
              <>
                <label>About Organisation</label>
                <textarea
                  name="about"
                  className={`form-control ${
                    errorsValidation.about_organization ? "input-error" : ""
                  }`}
                  rows="5"
                  value={organizationData.about_organization || ""}
                  onChange={(e) => {
                    setErrorsValidation({
                      ...errorsValidation,
                      about_organization: "",
                    });
                    setOrganizationData({
                      ...organizationData,
                      about_organization: e.target.value,
                    });
                  }}
                  disabled={editable === "disable"}
                  placeholder="Write about your organization"
                />
                {errorsValidation.about_organization && (
                  <span className="error-message">
                    {errorsValidation.about_organization}
                  </span>
                )}
              </>
            )}

            {/* KYB Information */}
            {/* <div className="section-header">
              Know Your Business (KYB) Information
            </div> */}

            {isPreview ? (
              <>
                <div className="section-header">
                  Know Your Business (KYB) Information
                </div>
                <div className="kyb-section">
                  <div className="kyb-preview">
                    {uploadedFiles.map((file, index) => {
                      console.log(file);
                      return (
                        <div key={index}>
                          <img src={file} alt={`Document ${index + 1}`} />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="section-header">
                  Know Your Business (KYB) Information
                </div>

                <div className="kyb-description">
                  <p>
                    To help us verify your organization, please upload the
                    relevant business or NGO registration documents below.
                  </p>
                  <p>
                    <strong>For Businesses:</strong> Upload your incorporation
                    and tax-related certificates (e.g., Business Registration,
                    VAT Certificate, Company Patent, etc.)
                  </p>
                  <p>
                    <strong>For NGOs / Non-profits:</strong> Upload your NGO
                    License or equivalent government authorization.
                  </p>
                  <p>
                    You may upload multiple files if your verification documents
                    are separate (PDF, JPG, PNG, DOC formats accepted). Once
                    verified, your organization will receive a Verified Badge
                    and gain access to additional features.
                  </p>
                </div>
                {isPreview === true ? (
                  <div className="kyb-preview">
                    {uploadedFiles.map((fileObj, index) => {
                      // Only show preview if the file is an image
                      const url = fileObj.preview || fileObj.url || "";
                      const isImage = /\.(jpg|jpeg|png)$/i.test(
                        fileObj.name || url
                      );

                      if (!isImage) return null;

                      return (
                        <div key={index} className="preview-item">
                          <img
                            src={url}
                            className="uploaded-image"
                            alt={`Document ${index + 1}`}
                          />
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <>
                    {uploadedFiles.map((fileObj, index) => (
                      <div key={index} className="regis-form-upload">
                        <label className="upload-input upload-control">
                          {fileObj ? (
                            <div className="upload-input-preview">
                              <img
                                src={fileObj}
                                alt="Uploaded"
                                className="uploaded-image"
                              />
                              <p className="file-name">{fileObj}</p>
                            </div>
                          ) : (
                            <span className="upload-placeholder">
                              Upload File
                            </span>
                          )}

                          <input
                            type="file"
                            accept=".pdf,.png,.jpg,.jpeg,.doc,.docx"
                            onChange={(e) => handleFileChange(e, index)}
                          />
                        </label>

                        <button
                          type="button"
                          className="social-delete-btn"
                          onClick={() => removeFileField(index)}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    ))}

                    <button
                      type="button"
                      className="add-file-btn"
                      onClick={addNewFileField}
                    >
                      + Add File
                    </button>

                    {errorsValidation.updatedFiles && (
                      <span className="error">
                        {errorsValidation.updatedFiles}
                      </span>
                    )}
                  </>
                )}
              </>
            )}

            {!isPreview && (
              <div className="submit-btn-container">
                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </div>
            )}
          </form>
        </div>
      </section>
    </>
  );
};

export default RegisterYourBussiness;
